export const alPrimaryTeal = '#006272'
export const alBlack = '#2c2a29'
export const alRed = '#c55050'
export const alWhite = '#ffffff'
export const alCoolGrey10 = '#63666a'
export const alOrange = '#e77200'
export const alTeal5 = '#f2f7f8'
export const alOrange5 = '#fef8f2'
export const alBoxShadow = '0 6px 9px 0 rgba(0, 0, 0, 0.1)'
